import { RewardBar, RewardName } from "./CountBar.styled";
import { useI18n } from '@i18n/useI18n';
import { useEffect, useRef, useState } from "react";
import { useStore } from "@store/appStore";
import Tooltip from "@components/Tooltips/Tooltip";


interface IProps{
    maxCount:number,
    title:string,
    count:number,
}

const CountBar = (props:IProps) =>{
    const i18n = useI18n();
    const [width, setWidth] = useState(0)
    
    useEffect(() => {
        setTimeout(() => {
            setWidth(GetWidthProcent(props.count, props.maxCount))
        }, 500)
    }, [])

    function GetWidthProcent(amount:number, max:number){
        return (amount / max) * 100;
    }


    return (<>
        <RewardName>{props.title}<div /></RewardName>
        <Tooltip delayEnter={200} delayLeave={200} content={i18n.t("total") + " " + i18n.t("redeemed") + ": " + props.count}>
            <RewardBar barWidth={width}>
                <div />
            </RewardBar>
        </Tooltip>                
    </>)
}

export default CountBar;